<template>
  <div>
    <header-component/>

    <div class="px-2 py-2 w-full">
      <div class="card">
        <div class="card-header">
          <h3 
            class="mb-0" 
            style="text-transform:capitalize;">Labor Cost List</h3>
          <div class="text-right">
            <el-select
              v-model="categoryId"
              filterable
              clearable
              placeholder="Service Category"
              size="small"
              class="mr-2"
              style="width: 200px;"
              @change="onCategoryChange"
            >
              <el-option
                v-for="item in serviceCategories"
                :key="item.serviceCategoryId"
                :label="item.label"
                :value="item.serviceCategoryId"
              />
            </el-select>
            <el-select
              v-model="serviceId"
              filterable
              clearable
              placeholder="Service"
              size="small"
              class="mr-2"
              style="width: 200px;"
            >
              <el-option
                v-for="item in serviceOptions"
                :key="item.serviceId"
                :label="item.label"
                :value="item.serviceId"
              />
            </el-select>
            <base-button 
              size="sm" 
              type="primary" 
              @click="insertLaborCost">Add New</base-button>
          </div>
        </div>
        <el-table
          :data="sortedLaborCostList"
          class="table-responsive table-flush"
          header-row-class-name="thead-light"
        >
          <el-table-column 
            label="Description" 
            prop="description"/>
          <el-table-column label="Service Category">
            <template slot-scope="scope">
              {{ categoryLabel(scope.row.service) }}
            </template>
          </el-table-column>
          <el-table-column label="Service">
            <template slot-scope="scope">
              <span v-if="scope.row.service">
                {{ scope.row.service.label }}
              </span>
            </template>
          </el-table-column>
          <el-table-column 
            label="Cost" 
            prop="cost"/>
          <el-table-column 
            min-width="70px" 
            label="Actions">
            <template slot-scope="scope">
              <el-dropdown 
                slot="dropdown" 
                @command="command => handleAction(scope.row, command)">
                <el-button 
                  type="primary" 
                  size="mini">
                  Actions
                  <i class="el-icon-arrow-down el-icon--right" />
                </el-button>
                <el-dropdown-menu 
                  slot="dropdown" 
                  class="dropdown-menu dropdown-menu-arrow show">
                  <el-dropdown-item command="edit">Edit</el-dropdown-item>
                  <el-dropdown-item command="delete" style="color: #f56c6c">Delete</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <el-dialog
        :visible.sync="addLaborCost" 
        title="Add Labor Cost">
        <add-labor-cost @close="addLaborCost = false" />
      </el-dialog>
    </div>
  </div>
</template>
<script>
import headerComponent from "../Components/HeaderComponent";
import { mapActions, mapMutations, mapGetters } from "vuex";
import Api from "@/middleware/api";
import endpoints from "@/utils/constants";
import AddLaborCost from "./AddLaborCost";
import {
  Button,
  TableColumn,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  Select,
  Dialog,
  DatePicker,
  Table,
  Option
} from "element-ui";
export default {
  components: {
    [Button.name]: Button,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Dropdown.name]: Dropdown,
    [DropdownMenu.name]: DropdownMenu,
    [DropdownItem.name]: DropdownItem,
    [Select.name]: Select,
    [Option.name]: Option,
    [DatePicker.name]: DatePicker,
    [Dialog.name]: Dialog,
    "add-labor-cost": AddLaborCost,
    "header-component": headerComponent
  },
  data: () => {
    return {
      addLaborCost: false,
      categoryId: null,
      serviceId: null
    };
  },

  computed: {
    ...mapGetters({
      laborCostList: "laborCost/getLaborCosts",
      getLaborCost: "laborCost/getgetLaborCost",
      serviceCategories: "serviceCategory/getServiceCategoryList",
      serviceList: "service/getServiceList"
    }),
    serviceOptions() {
      return [...(this.serviceList || [])]
        .filter(row => !this.categoryId || row.serviceCategoryId === this.categoryId)
        .sort((a, b) => (a.label || '').localeCompare(b.label || ''));
    },
    sortedLaborCostList() {
      return [...(this.laborCostList || [])]
        .filter(row => {
          const rowCategoryId = row.service && row.service.serviceCategoryId;
          if (this.categoryId && rowCategoryId !== this.categoryId) return false;
          if (this.serviceId && row.serviceId !== this.serviceId) return false;
          return true;
        })
        .sort((a, b) => (a.description || '').localeCompare(b.description || ''));
    }
  },

  mounted() {
    this.getLaborCosts();
    this.getServiceCategoryList();
    this.getServiceList();
  },

  methods: {
    ...mapActions({
      getLaborCosts: "laborCost/getLaborCosts",
      fetchlaborCost: "laborCost/fetchlaborCost",
      getServiceCategoryList: "serviceCategory/getServiceCategoryList",
      getServiceList: "service/getServiceList"
    }),
    categoryLabel(service) {
      if (!service || !service.serviceCategoryId) return "";
      const match = (this.serviceCategories || []).find(
        item => item.serviceCategoryId === service.serviceCategoryId
      );
      return match ? match.label : "";
    },
    onCategoryChange() {
      if (!this.serviceId) return;
      const stillVisible = this.serviceOptions.some(item => item.serviceId === this.serviceId);
      if (!stillVisible) this.serviceId = null;
    },
    ...mapMutations({
      resetLaborCost: "laborCost/resetLaborCost",
      setlaborCost: "laborCost/setlaborCost"
    }),
    insertLaborCost() {
      this.resetLaborCost();
      this.addLaborCost = true;
    },
    handleAction(laborCost, command) {
      if (command === "edit") {
        this.fetchlaborCost(laborCost.laborCostId).then(res => {
          this.setlaborCost(res);
          this.addLaborCost = true;
        });
      } else if (command === "delete") {
        if (!window.confirm("Delete this labor cost?")) return;
        new Api().call("delete", `${endpoints.LARAVEL_BASE_URL}/api/v1/labor-costs/${laborCost.laborCostId}`)
          .then(() => {
            this.getLaborCosts();
            window.notify && window.notify({ message: "Deleted", type: "success", title: "Success" });
          })
          .catch(() => {
            window.notify && window.notify({ message: "Failed to delete", type: "danger", title: "Error" });
          });
      }
    }
  }
};
</script>